import { render, staticRenderFns } from "./SportTypeBadge.vue?vue&type=template&id=2f00c3a7&scoped=true"
import script from "./SportTypeBadge.vue?vue&type=script&lang=ts"
export * from "./SportTypeBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f00c3a7",
  null
  
)

export default component.exports